import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import DashboardLayout from "@/components/DashboardLayout";
import MatchScore from "@/components/MatchScore";
import { api } from "@/lib/api";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";

export default function CreatorMatches() {
  const { t } = useTranslation();
  const [projects, setProjects] = useState([]);
  const [selected, setSelected] = useState("");
  const [matches, setMatches] = useState([]);

  useEffect(() => {
    (async () => {
      const { data } = await api.get("/api/projects/mine");
      setProjects(data);
      if (data.length > 0) setSelected(data[0].id);
    })();
  }, []);

  useEffect(() => {
    if (!selected) return;
    (async () => {
      const { data } = await api.get(`/api/matches/for-project/${selected}`);
      setMatches(data);
    })();
  }, [selected]);

  return (
    <DashboardLayout
      title={t("creator_matches.title")}
      subtitle={t("creator_matches.subtitle")}
    >
      {projects.length === 0 ? (
        <div className="kpi-card p-8 text-center">
          <p className="text-slate-500">{t("creator_matches.need_project")}</p>
          <Link to="/dashboard/proyectos/nuevo" className="mt-4 inline-block text-petroleum hover:text-gold">{t("creator_matches.create_project_link")}</Link>
        </div>
      ) : (
        <>
          <div className="flex items-center gap-3 mb-6">
            <span className="text-sm text-slate-500">{t("creator_matches.project_label")}</span>
            <Select value={selected} onValueChange={setSelected}>
              <SelectTrigger className="w-80" data-testid="select-project"><SelectValue /></SelectTrigger>
              <SelectContent>
                {projects.map((p) => <SelectItem key={p.id} value={p.id}>{p.title}</SelectItem>)}
              </SelectContent>
            </Select>
          </div>
          {matches.length === 0 ? (
            <div className="text-slate-500">{t("creator_matches.no_matches")}</div>
          ) : (
            <div className="grid gap-4">
              {matches.map((m, i) => (
                <div key={m.brief.id || i} className="kpi-card p-6 flex flex-col md:flex-row gap-6" data-testid={`row-match-${i}`}>
                  <MatchScore score={m.score} size="lg" />
                  <div className="flex-1">
                    <p className="text-xs uppercase tracking-widest text-slate-500">{t("creator_matches.brief_eyebrow")}</p>
                    <h3 className="font-display text-2xl text-petroleum mt-1">{m.brief.title}</h3>
                    <p className="text-sm text-slate-500 mt-1">{m.brief.description}</p>
                    <div className="mt-4 grid grid-cols-2 md:grid-cols-4 gap-2">
                      {m.reasons.map((r, j) => (
                        <div key={r.label || j} className="border border-slate-200 rounded-lg px-3 py-2">
                          <p className="text-[10px] uppercase tracking-widest text-slate-500">{r.label}</p>
                          <div className="flex items-end gap-1 mt-1">
                            <span className="text-lg font-display text-petroleum">{r.score}%</span>
                            <span className="text-[10px] text-slate-400 mb-0.5">{t("creator_matches.weight_label", { weight: r.weight })}</span>
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
              ))}
            </div>
          )}
        </>
      )}
    </DashboardLayout>
  );
}
